 <template>
  <div>
    <!-- 弹窗 -->
    <div class="delete_view">
      <el-dialog
        title="试题设置"
        :visible.sync="dialogVisibleSon"
        :close-on-click-modal="false"
        @closed="handleClose('ruleForm')"
      >
        <div class="delete_mian">
          <!-- tabs -->
          <div class="mian-box">
            <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
              <el-tab-pane label="考试试卷" name="first">
                <div class="card">
                  <div class="time_input">
                    <div>
                      <span class="demonstration">搜索栏：</span>
                      <el-input
                        v-model="value"
                        placeholder="根据试卷名称进行搜索"
                      ></el-input>
                    </div>
                    <div>
                      <el-button
                        type="primary"
                        icon="el-icon-search"
                        class="searchbtn"
                        @click="handleQuery"
                        >搜索</el-button
                      >
                      <el-button plain class="searchbtn" @click="resetForm()"
                        ><i class="iconfont icon-zhongzhi- special_btn"></i
                        >重置</el-button
                      >
                    </div>
                  </div>
                  <!-- 表单内容 -->
                  <div class="hos_table" v-loading="loading">
                    <el-table
                      :data="getData"
                      style="width: 100%"
                      ref="table"
                      :row-class-name="tableRowClassName"
                      @selection-change="handleSelectionChange"
                      :row-key="getRowKeyOfTarget"
                      :header-cell-style="{
                        'background-color': '#8FCBFF',
                        color: '#333333',
                        height: '60px',
                      }"
                    >
                      <el-table-column
                        type="selection"
                        width="80"
                        class="aa"
                        :reserve-selection="true"
                        :selectable="selectable"
                      >
                      </el-table-column>
                      <el-table-column
                        v-for="(item, index) in formColumns"
                        :key="index"
                        :prop="item.prop"
                        :label="item.label"
                        :width="item.width"
                        height="150"
                        label-height="50"
                        align="center"
                      >
                      </el-table-column>
                    </el-table>
                  </div>
                  <!-- 分页 -->
                  <div class="foot_box">
                    <div class="foot_pagetions">
                      <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-size="pageSize"
                        :current-page.sync="currentPage3"
                        :page-sizes="pagesizesarr"
                        layout="prev, pager, next,sizes, jumper"
                        :total="total"
                        class="pagination"
                      >
                      </el-pagination>
                    </div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="练习试卷" name="second">
                <div class="second">
                  <div class="time_input">
                    <div>
                      <span class="demonstration">搜索栏：</span>
                      <el-input
                        v-model.trim="value1"
                        placeholder="根据练习名称进行搜索"
                      ></el-input>
                    </div>
                    <div>
                      <el-button
                        type="primary"
                        icon="el-icon-search"
                        class="searchbtn"
                        @click="handleQueryTow"
                        >搜索</el-button
                      >
                      <el-button plain class="searchbtn" @click="resetForm2()"
                        ><i class="iconfont icon-zhongzhi- special_btn"></i
                        >重置</el-button
                      >
                    </div>
                  </div>
                  <!-- 表单内容 -->
                  <div class="hos_table" v-loading="isLoading">
                    <el-table
                      :data="getDataTwo"
                      style="width: 100%"
                      ref="ruleForm"
                      :row-class-name="tableRowClassName"
                      :row-key="addtRowKeyOfTarget"
                      @selection-change="handleSelectionChangeTow"
                      :header-cell-style="{
                        'background-color': '#8FCBFF',
                        color: '#333333',
                        height: '60px',
                      }"
                    >
                      <el-table-column
                        type="selection"
                        width="80"
                        class="aa"
                        :reserve-selection="true"
                        :selectable="selectableTow"
                      >
                      </el-table-column>
                      <el-table-column
                        v-for="(item, index) in formColumns"
                        :key="index"
                        :prop="item.prop"
                        :label="item.label"
                        :width="item.width"
                        height="150"
                        label-height="50"
                        align="center"
                      >
                      </el-table-column>
                    </el-table>
                  </div>
                  <!-- 分页 -->
                  <div class="foot_box">
                    <div class="foot_pagetions">
                      <el-pagination
                        @size-change="handleSizeChangeTow"
                        @current-change="handleCurrentChangeTow"
                        :page-size="pageSize2"
                        :page-sizes="pagesizesarr2"
                        :current-page.sync="currentPage2"
                        layout="prev, pager, next,sizes, jumper"
                        :total="totalTow"
                        class="pagination"
                      >
                      </el-pagination>
                    </div>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisibleSon = false">取 消</el-button>
          <el-button type="primary" @click="toconfirm">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

 <script>
import { addPapers } from "@/api/examination.js";
import { times } from "@/mixin/time";
import loginvuex from "@/store/index";
export default {
  data() {
    return {
      activeName: "first",
      dialogVisibleSon: false,
      loading: true, //考试
      isLoading: true, //练习
      testtype: "1",
      value: "", // 考试查询
      isValue: "",
      value1: "", // 练习查询
      isValue1: "",
      rowStabe: {},
      currentPage3: 1, //  当前页数
      reqcurrentPage3: 0, //请求的页码数
      pagesizesarr: [5, 10, 20, 50, 100],
      pageSize: 5, //每页的条数
      total: 100,
      totalTow: 100,
      getData: [], // 考试试卷
      getDataTwo: [], // 练习试卷
      currentPage2: 1, //  当前页数--->练习
      reqcurrentPage2: 0, //请求的页码数--->练习
      pagesizesarr2: [5, 10, 20, 50, 100], //  当前页数--->练习
      pageSize2: 5, //每页的条数 --->练习
      title: {}, //试卷组卷处理的键名
      multipleSelection: [], // 考试的
      multipleSelectionIds: [],
      multipleSelectionCount: 0,
      multipleSelection2: [], // 练习的
      multipleSelectionIdsTwo: [],
      multipleSelectionCountTwo: 0,
      theEndmultipleSelection: [], // 试卷和练习一起组合数组
      endDataArr: [], // 试卷和练习一起的数据
      volumeMax: "", // 长度拦截
      formColumns: [
        {
          prop: "PaperTitle",
          label: "试卷名称",
          // width: "90px",
        },
        {
          prop: "BeginTime1",
          label: "考试时间",
          width: "320px",
        },
        {
          prop: "TestCount",
          label: "总分（分）",
          // width: "90px",
        },
        {
          prop: "StudentCount",
          label: "参与人数（人）",
          // width: "90px",
        },
      ],
    };
  },
  mixins: [times], // 引入共用方法
  methods: {
    // 考试的搜索
    handleQuery() {
      this.$refs.table.clearSelection();
      this.loading = true;
      this.currentPage3 = 1;
      if (this.value) {
        this.isValue = this.value;
      } else {
        this.isValue = "";
      }
      this.addExaminList();
    },
    // 练习的搜索
    handleQueryTow() {
      this.$refs.ruleForm.clearSelection();
      this.isLoading = true;
      this.currentPage2 = 1;
      if (this.value1) {
        this.isValue1 = this.value1;
      } else {
        this.isValue1 = "";
      }
      this.addPracticeInList();
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    changetesttype(type) {
      if (this.testtype !== type) {
        if (this.testtype === "1") {
          this.testtype = "0";
          this.addExaminList();
        } else {
          this.testtype = "1";
          this.addExaminList();
        }
      }
    },
    toconfirm() {
      this.endDataArr = this.multipleSelection.concat(this.multipleSelection2); // 这是考试和练习拼接起来的一个数组对象
      if (this.endDataArr.length < 1) {
        this.dialogVisibleSon = true;
        this.$message.warning("请选择试题");
      } else {
        if(this.overTimerState == false){
          this.overTimerState = true
          this.timeIsaddtest()
        }
        this.dialogVisibleSon = false;
        this.$parent.isaddtest = false; // 添加图片隐藏
        this.theEndmultipleSelection = this.multipleSelectionIds.concat(
          this.multipleSelectionIdsTwo
        ); // 这是考试和练习拼接出来的ID数组
        this.theEndmultipleSelection.map((item) => {
          this.title = JSON.stringify(item.PaperTitle + "|" + item.ExamID);
        });
        console.log(this.title, "拼接出来的数据2");
        this.$emit("multipleData", this.endDataArr);
      }
    },
    // 清除关闭弹窗时正则校验状态
    handleClose(formExamin) {
      console.log("handleClose...", this.$refs[formExamin]);
      // this.$refs.table.clearSelection();
      // this.$refs.ruleForm.clearSelection();
      this.isValue = "";
      this.value = "";
      this.isValue1 = "";
      this.value1 = "";
    },
    // 分页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.loading = true;
      this.pageSize = val;
      this.addExaminList();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage3 = val;
      this.loading = true;
      this.addExaminList();
    },
    handleSelectionChange(val) {
      console.log("TwoSon.vue点击复选框========");
      // 初始化全局表格多选框
      this.multipleSelectionIds = [];
      this.multipleSelection = [];
      this.multipleSelectionCount = 0;
      this.multipleSelection = val;
      this.multipleSelectionIds = val.map((v) => {
        return { PaperTitle: v.PaperTitle, ExamID: v.ExamID };
      });
      this.multipleSelectionCount = this.multipleSelection.length;
      // 考试和练习的数量超过拦截
      let a = this.multipleSelection.length;
      let b = this.multipleSelection2.length;
      this.volumeMax = a + b;
      if (a + b >= 5) {
        this.$message({
          message: "当前试卷(练习)共计已勾选五个，不能超过五个",
          type: "warning",
        });
      }
    },
    // 给每一行设置key
    getRowKeyOfTarget(row) {
      return row.ExamID;
    },
    // 练习给每一行设置key
    addtRowKeyOfTarget(row) {
      return row.ExamID;
    },
    // 练习的分页
    // 分页
    handleSizeChangeTow(val) {
      console.log(`每页 ${val} 条`);
      this.isLoading = true;
      this.pageSize2 = val;
      this.addPracticeInList();
    },
    handleCurrentChangeTow(val) {
      console.log(`当前页: ${val}`);
      this.isLoading = true;
      this.currentPage2 = val;
      this.addPracticeInList();
    },
    handleSelectionChangeTow(val) {
      // 初始化全局表格多选框
      this.multipleSelectionIdsTwo = [];
      this.multipleSelection2 = [];
      this.multipleSelectionCountTwo = 0;
      this.multipleSelection2 = val;
      this.multipleSelectionIdsTwo = val.map((v) => {
        return { PaperTitle: v.PaperTitle, ExamID: v.ExamID };
      });

      this.multipleSelectionCountTwo = this.multipleSelection2.length;
      // 考试和练习的数量超过拦截
      let a = this.multipleSelection.length;
      let b = this.multipleSelection2.length;
      this.volumeMax = a + b;
      if (a + b >= 5) {
        this.$message({
          message: "当前试卷(练习)共计已勾选五个，不能超过五个",
          type: "warning",
        });
      }
    },
    // 表格背景颜色
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "success-row";
      } else if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "";
    },
    selectable(row) {
      let arr = this.multipleSelection.findIndex(
        (v) => v.ExamID === row.ExamID
      );
      let a = this.multipleSelection.length;
      let b = this.multipleSelection2.length;
      if (a + b >= 5) {
        if (arr !== -1) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    selectableTow(row) {
      let arr = this.multipleSelection2.findIndex(
        (v) => v.ExamID === row.ExamID
      );
      let a = this.multipleSelection.length;
      let b = this.multipleSelection2.length;
      if (a + b >= 5) {
        if (arr !== -1) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    // 重置
    resetForm() {
      this.value = "";
      this.currentPage3 = 1;
      this.isValue = "";
      this.loading = true;
      this.addExaminList();
    },
    // 重置
    resetForm2() {
      this.value1 = "";
      this.isValue1 = "";
      this.currentPage2 = 1;
      this.isLoading = true;
      this.addPracticeInList();
    },
    // 处理时间拼接
    joiningTime() {
      this.getData.map((item) => {
        item.BeginTime1 =
          this.$moment(item.BeginTime).format("YYYY/MM/DD HH:mm") +
          "-" +
          this.$moment(item.EndTime).format("YYYY/MM/DD HH:mm");
        // 为空判断
        for (let ztiem in item) {
          if (
            item[ztiem] === "" ||
            item[ztiem] === "Invalid date-Invalid date"
          ) {
            item[ztiem] = "未设置";
          }
        }
      });
    },
    // 练习时间处理
    PracticTime() {
      this.getDataTwo.map((item) => {
        item.BeginTime1 =
          this.$moment(item.BeginTime).format("YYYY/MM/DD HH:mm") +
          "-" +
          this.$moment(item.EndTime).format("YYYY/MM/DD HH:mm");
        // 为空判断
        for (let ztiem in item) {
          if (
            item[ztiem] === "" ||
            item[ztiem] === "Invalid date-Invalid date"
          ) {
            item[ztiem] = "未设置";
          }
        }
      });
    },
    // 考试列表
    async addExaminList() {
      let params = {
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        ExamType: 0, // 为0是考试，为1是练习
        searchStr: this.isValue,
        PageIndex: this.currentPage3 - 1,
        PageShow: this.pageSize,
      };
      let checkedrow = [];

      if (this.testtype == "1") {
        const Data = await addPapers(params);
        if (Data.data.Status === 200) {
          this.getData = Data.data.Data.Data;
          this.total = Data.data.Data.count;
          setTimeout(() => {
            this.loading = false;
          }, 500);

          this.joiningTime();
        } else {
          this.$message.error("数据获取不到");
        }
      }
    },
    // 练习列表
    async addPracticeInList() {
      let params = {
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        ExamType: 1, // 为0是考试，为1是练习
        searchStr: this.isValue1,
        PageIndex: this.currentPage2 - 1,
        PageShow: this.pageSize2,
      };
      if (this.testtype == "1") {
        const Data = await addPapers(params);
        if (Data.data.Status === 200) {
          this.getDataTwo = Data.data.Data.Data;
          this.totalTow = Data.data.Data.count;
          setTimeout(() => {
            this.isLoading = false;
          }, 500);
          console.log(this.getDataTwo, "这里是数据源");
          this.PracticTime();
        } else {
          this.$message.error("数据获取不到");
        }
      }
    },
  },
  created() {
    this.addExaminList();
    this.addPracticeInList();
  },
};
</script>

 <style lang="scss" scoped>
.delete_view {
  ::v-deep .el-dialog__header {
    height: 55px;
    background: linear-gradient(
      180deg,
      #64b5ff 0%,
      rgba(199, 228, 255, 1) 100%
    );
    opacity: 1;
    border-radius: 5px 5px 0px 0px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333333;
  }
  ::v-deep .dialog-footer {
    margin-bottom: 30px;
  }
  ::v-deep .el-dialog__footer span > button:nth-child(2) {
    margin-left: 50px;
  }
  ::v-deep.el-dialog__footer {
    justify-content: center !important;
  }
  ::v-deep .el-dialog__body {
    padding: 0px;
  }
  .delete_mian {
    box-sizing: border-box;

    p {
      text-align: left;
      font-size: 15px;
    }
  }

  .el-dialog__footer span > button {
    margin-top: 10px;
  }
}
::v-deep .el-dialog {
  width: 910px;
  // height: 1000px;
  // min-height: 700px;
  border-radius: 5px;
}
::v-deep .el-dialog__wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
::v-deep .el-dialog__footer {
  padding: 0;
  display: flex;
  justify-content: center;
  align-content: center;
  text-align: center;
  span > button {
    width: 60px;
    height: 32px;
    opacity: 1;
    border-radius: 4px;
    padding: 0px;
    margin-top: 38px;
  }
}
.testtypebutton {
  background-color: rgb(255, 255, 255);
  //border-bottom: 1px solid #eeeeee;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  border-bottom: 1px solid #f8f8f8;
  padding: 24px 0;
}
.testtypebtn {
  width: 180px;
  height: 50px;
  background: #ffffff;
  border: 1px solid #1890ff;
  font-family: PingFang SC;
  border: 1px solid#1890FF;
  border-radius: 5px 0px 0px 5px;
  &:nth-child(2) {
    border-left: none;
    border-radius: 0px 5px 5px 0px;
  }
  //border-radius: 0px 5px 5px 0px;
}
.isactivetype {
  color: #ffffff;
  background-color: #1890ff;
}
.time_input {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 88px;
  padding: 0px 24px;
  .searchbtn {
    margin-left: 25px;
    width: 88px;
    height: 40px;
  }
  .el-input {
    width: 360px;
  }
  .el-date-picker {
    width: 380px;
    height: 40px;
  }
  ::v-deep .el-date-editor .el-range-separator {
    width: 6%;
  }
  ::v-deep .el-range-editor.el-input__inner {
    width: 380px;
  }
  .special_btn {
    font-size: 16px !important;
    margin-right: 5px;
  }
}
.hos_table {
  height: 380px;
  overflow-y: scroll;
  padding: 0 24px;
  scrollbar-face-color: none !important;
  &::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 4px;
  }
  &::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 5px;
    //  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: linear-gradient(
      180deg,
      #64b5ff 0%,
      rgba(199, 228, 255, 1) 100%
    );
  }
  & ::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    // -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 0;
    background: linear-gradient(
      180deg,
      #64b5ff 0%,
      rgba(199, 228, 255, 1) 100%
    );
  }
  scrollbar-base-color: red;
  // .el-checkbox:last-of-type{

  // }
}
// 分页
.foot_box {
  position: relative;
  height: 88px;
}
.foot_pagetions {
  display: flex;
  position: absolute;
  right: 16px;
  bottom: 30px;
  p {
    //background-color: #333333;
    text-align: center;
    line-height: 32px;
    font-family: 微软雅黑;
    color: #949494;
  }
  span {
    line-height: 32px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
    b {
      color: #ff0000;
    }
  }
}
.pagination {
  ::v-deep .el-pager {
    li {
      border: 1px solid #d9d9d9;
      margin-right: 8px;
      &.active {
        color: #ffffff;
        background-color: #409eff;
        border: none;
      }
    }
  }
  // ::v-deep .el-pagination__jump {
  //   // &::before {
  //   //   content: "10条/页";
  //   //   width: 82px;
  //   //   border: 1px solid #d9d9d9;
  //   //   height: 28px;
  //   //   border-radius: 2px;
  //   //   text-align: center;
  //   //   display: inline-block;
  //   //   margin-right: 8px;
  //   //   cursor: pointer;
  //   // }
  // }
}
::v-deep .el-table th:nth-child(1) {
  opacity: 1;
  border-radius: 10px 0px 0px 0px;
}
::v-deep .el-table th:nth-child(5) {
  opacity: 1;
  border-radius: 0px 10px 0px 0px;
}
::v-deep .el-table .cell {
  text-align: center;
}
::v-deep .el-table .success-row {
  background: #f8fcff !important;
}
::v-deep .el-range-separator {
  color: #eeeeee !important;
}
::v-deep .el-table__header-wrapper {
  .has-gutter {
    // background-color: chocolate;
    > tr {
      > th:nth-child(1) {
        > div {
          .el-checkbox__input {
            display: none;
          }
        }
        //display: none;
      }
    }
  }
}
// tabs样式
.el-tabs {
  margin-top: 50px;
}
.mian-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  ::v-deep .el-tabs__nav {
    display: flex;
    border: 1px solid #1890ff;
  }
  ::v-deep .el-tabs__item {
    width: 180px;
    height: 40px;
    line-height: 40px;
    //   padding: 0 40px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  ::v-deep .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
    //    border-bottom-color: #1890FF;
    border: 1px solid #1890ff;
    background: #1890ff;
    color: #ffffff;
  }
  ::v-deep .el-tabs--card > .el-tabs__header {
    border: none;
    display: flex;
    justify-content: center;
    width: 100%;
  }
}
.card {
  width: 858px;
}
.second {
  width: 858px;
}
</style>
